<script lang="ts">
    import type { Bootstrap } from '$src/lib/services/legacy/auth/types';
    import { browser } from '$app/environment';
    import GatekeeperContext from './GatekeeperContext.svelte';

    export let authBootstrap: Bootstrap;
    export let onGatekeeperInitiated: () => void;
</script>

{#if browser}
    <GatekeeperContext {authBootstrap} {onGatekeeperInitiated} />
{/if}
